import { render, staticRenderFns } from "./ModalTrocarVale.vue?vue&type=template&id=5de39a20&scoped=true"
import script from "./ModalTrocarVale.vue?vue&type=script&lang=js"
export * from "./ModalTrocarVale.vue?vue&type=script&lang=js"
import style0 from "./ModalTrocarVale.vue?vue&type=style&index=0&id=5de39a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de39a20",
  null
  
)

export default component.exports